var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTakePhoto = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "#F26663"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13.5V22.5C25 23.3281 24.3281 24 23.5 24H10.5C9.67188 24 9 23.3281 9 22.5V13.5C9 12.6719 9.67188 12 10.5 12H13.25L13.6344 10.9719C13.8531 10.3875 14.4125 10 15.0375 10H18.9594C19.5844 10 20.1438 10.3875 20.3625 10.9719L20.75 12H23.5C24.3281 12 25 12.6719 25 13.5ZM20.75 18C20.75 15.9313 19.0688 14.25 17 14.25C14.9313 14.25 13.25 15.9313 13.25 18C13.25 20.0688 14.9313 21.75 17 21.75C19.0688 21.75 20.75 20.0688 20.75 18ZM19.75 18C19.75 19.5156 18.5156 20.75 17 20.75C15.4844 20.75 14.25 19.5156 14.25 18C14.25 16.4844 15.4844 15.25 17 15.25C18.5156 15.25 19.75 16.4844 19.75 18Z",
    fill: "#F26663"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTakePhoto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/take-photo.fe73892d.svg";
export { ForwardRef as ReactComponent };